import { Link as RouterLink } from "react-router-dom";
import { Link, Tooltip } from "@mui/material";
import { yearFirstDateTimeFormat } from "src/utils/formatTime";
import { PaymentGatewayActionMenu } from "./PaymentGatewayActionMenu";
import { UpiQrDownload } from "./UpiQrDownload";

// Columns accepted in the bulk-import CSV. The order here is also the order
// used for the downloadable sample file. Field names must match the API.
export const paymentGatewayImportColumns = [
  "payment_gateway_id",
  "key_id",
  "key_secret",
  "webhook_secret",
  "currency",
  "country",
  "gateway_type",
  "name",
  "domain",
  "upi_url",
];

// A single example row used for the downloadable sample CSV.
export const paymentGatewaySampleRow = {
  payment_gateway_id: "1",
  key_id: "connector_name_123",
  key_secret: "your_key_secret",
  webhook_secret: "your_webhook_secret",
  currency: "INR",
  country: "IN",
  gateway_type: "razorpay",
  name: "Sample Gateway",
  domain: "example.com",
  upi_url: "upi://pay?pa=paytm.s1gh6sr@pty&pn=Paytm",
};

export const getPaymentGatewayDefaultValues = () => ({
  payment_gateway_id: "",
  key_id: "",
  key_secret: "",
  webhook_secret: "",
  currency: "INR",
  country: "IN",
  gateway_type: "",
  name: "",
  domain: "",
  upi_url: "",
});

export const paymentGatewayListColumns = (isReadOnly) => [
  {
    field: "name",
    headerName: "Name",
    flex: 1,
    minWidth: 150,
    renderCell: ({ value, id, row }) => (
      <>
        {isReadOnly ? (
          value || "-"
        ) : (
          <Link underline="none" component={RouterLink} to={`${id}`}>
            {value || "-"}
          </Link>
        )}
      </>
    ),
  },
  {
    field: "gateway_type",
    headerName: "Gateway Type",
    flex: 1,
    minWidth: 120,
    valueFormatter: ({ value }) => value || "-",
  },
  {
    field: "currency",
    headerName: "Currency",
    flex: 1,
    minWidth: 100,
    valueFormatter: ({ value }) => value || "-",
  },
  {
    field: "country",
    headerName: "Country",
    flex: 1,
    minWidth: 100,
    valueFormatter: ({ value }) => value || "-",
  },
  {
    field: "domain",
    headerName: "Domain",
    flex: 1,
    minWidth: 150,
    valueFormatter: ({ value }) => value || "-",
  },
  {
    field: "key_id",
    headerName: "Connector Name",
    flex: 1,
    minWidth: 150,
    valueFormatter: ({ value }) => value || "-",
  },
  {
    field: "charger_id",
    headerName: "Charger ID",
    flex: 1,
    minWidth: 130,
    valueFormatter: ({ value }) => value || "-",
  },
  {
    field: "connector_id",
    headerName: "Connector ID",
    flex: 1,
    minWidth: 130,
    valueFormatter: ({ value }) => value || "-",
  },
  {
    field: "upi_qr",
    headerName: "UPI QR",
    width: 90,
    sortable: false,
    filterable: false,
    renderCell: ({ row }) => (
      <UpiQrDownload upiUrl={row.upi_url} rowId={row.id} />
    ),
  },
  {
    field: "created_date",
    headerName: "Created Date",
    flex: 1,
    minWidth: 180,
    renderCell: ({ value }) => (
      <Tooltip title={value ? yearFirstDateTimeFormat(value) : "-"} placement="top">
        <span>{value ? yearFirstDateTimeFormat(value) : "-"}</span>
      </Tooltip>
    ),
  },
  ...(!isReadOnly
    ? [
        {
          field: "actions",
          headerName: "",
          type: "actions",
          width: 50,
          getActions: (params) => [
            <PaymentGatewayActionMenu id={params.id} row={params.row} />,
          ],
        },
      ]
    : []),
];

